var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayslip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#44AF69",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 23.375H23.375V24.75H17.875V23.375ZM17.875 19.9375H26.125V21.3125H17.875V19.9375ZM17.875 26.8125H21.3125V28.1875H17.875V26.8125Z",
    fill: "#44AF69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1875 14.4375H26.125V13.75C26.125 13.3853 25.9801 13.0356 25.7223 12.7777C25.4644 12.5199 25.1147 12.375 24.75 12.375H19.25C18.8853 12.375 18.5356 12.5199 18.2777 12.7777C18.0199 13.0356 17.875 13.3853 17.875 13.75V14.4375H15.8125C15.4478 14.4375 15.0981 14.5824 14.8402 14.8402C14.5824 15.0981 14.4375 15.4478 14.4375 15.8125V30.25C14.4375 30.6147 14.5824 30.9644 14.8402 31.2223C15.0981 31.4801 15.4478 31.625 15.8125 31.625H28.1875C28.5522 31.625 28.9019 31.4801 29.1598 31.2223C29.4176 30.9644 29.5625 30.6147 29.5625 30.25V15.8125C29.5625 15.4478 29.4176 15.0981 29.1598 14.8402C28.9019 14.5824 28.5522 14.4375 28.1875 14.4375ZM19.25 13.75H24.75V16.5H19.25V13.75ZM28.1875 30.25H15.8125V15.8125H17.875V17.875H26.125V15.8125H28.1875V30.25Z",
    fill: "#44AF69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayslip);
export default __webpack_public_path__ + "static/media/payslip.c159209657c761a0ada9cd01bfce6c9a.svg";
export { ForwardRef as ReactComponent };